import { Navigate, useParams } from "react-router-dom";
import SavePreventaPymes from "../../shared/componente/save_preventa_pymes/SavePreventaPymes";
import { LoaderComponent } from "@/shared/components/ui";
import { ROUTER_PATHS } from "@/shared";
import { useGetProspectoByIdProspectoPymes } from "@/shared/actions/erp/prospecto_pymes.action";

export default function CreatePreventaPymesPage() {
  const { id } = useParams();

  const {
    data,
    isLoading,
    isPending
  } = useGetProspectoByIdProspectoPymes(id!);

  if (isPending
    || isLoading) return <LoaderComponent />

  if (!data) return <Navigate to={ROUTER_PATHS.ventasPymes.prospectoNav} />;

  return <SavePreventaPymes dataProspecto={data} />

}